import IntersectionObserver from 'intersection-observer'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import smoothscroll from 'smoothscroll-polyfill'

Vue.config.productionTip = false

new Vue({
  IntersectionObserver,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
smoothscroll.polyfill()
